import React, { useEffect } from 'react'
import {
  MdDashboard,
  MdInventory,
  MdShoppingCart,
  MdSettings,
  MdVerifiedUser,
} from 'react-icons/md'
import './Navigation.scss'
import managerService from '../../services/managerService'
import authService from '../../services/authService'

const Navigation = ({
  currentTab,
  setCurrentTab,
  shopInfo,
  isInStandaloneMode,
  installed,
}) => {
  const tabs = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: MdDashboard,
      permission: 'viewDashboard',
    },
    {
      id: 'products',
      label: 'Produits',
      icon: MdInventory,
      permission: 'viewProducts',
    },
    {
      id: 'purchases',
      label: 'Achats',
      icon: MdShoppingCart,
      permission: 'viewPurchases',
    },
    {
      id: 'settings',
      label: 'Paramètres',
      icon: MdSettings,
      permission: 'viewSettings',
    },
  ]

  // FILTRER LES TABS SELON LES PERMISSIONS DE L'UTILISATEUR
  const visibleTabs = tabs.filter((tab) =>
    managerService.hasPermission(tab.permission),
  )

  // REDIRIGER SI LE TAB ACTUEL N'EST PAS AUTORISÉ
  useEffect(() => {
    const currentTabAllowed = visibleTabs.some((tab) => tab.id === currentTab)
    if (!currentTabAllowed && visibleTabs.length > 0) {
      setCurrentTab(visibleTabs[0].id) // Rediriger vers le premier tab accessible
    }
  }, [currentTab, visibleTabs, setCurrentTab])

  // RÉCUPÉRER LES INFOS DU GÉRANT
  const role = managerService.getCurrentManagerRole()
  const tokenInfo = authService.getTokenInfo()
  const managerName = tokenInfo?.managerName

  // ON DESACTIVE LE BOUTON INSTALLER SUR FIREFOX POUR CAUSE DE BUG
  const isFirefox = navigator.userAgent.toLowerCase().includes('firefox')

  return (
    <>
      {/* Navigation principale */}
      <nav className='nav-main'>
        <div
          className={`nav-content ${isInStandaloneMode ? 'nav-content-appIsInstall' : ''}`}
        >
          <div className='nav-flex'>
            <div
              className={`nav-brand ${isInStandaloneMode ? 'nav-brand-appIsInstall' : ''}`}
            >
              <div
                className={`nav-flex-content ${isInStandaloneMode ? 'nav-flex-content-appIsInstall' : ''}`}
              >
                <h1 className='nav-title'>
                  {shopInfo.shopName || (
                    <>
                      OGC<span style={{ color: 'red' }}>2</span>
                      <span style={{ color: 'rgb(184, 184, 0)' }}>2</span>
                      <span style={{ color: 'green' }}>4</span>
                    </>
                  )}
                </h1>
                <p>Powered by LAGUINDA WS</p>

                {/* Badge si gérant connecté */}
                {role === 'manager' && managerName && (
                  <div className='manager-badge'>
                    <MdVerifiedUser size={18} />
                    <span>{managerName}</span>
                  </div>
                )}
              </div>
            </div>

            <div className='nav-actions'>
              <div className='nav-tabs'>
                {visibleTabs.map((tab) => {
                  // const Icon = tab.icon
                  return (
                    <button
                      key={tab.id}
                      onClick={() => {
                        setCurrentTab(tab.id)
                        window.scrollTo(0, 0)
                      }}
                      className={`nav-tab ${
                        currentTab === tab.id ? 'active' : ''
                      }`}
                    >
                      {/* <Icon
                        size={20}
                        className='icon'
                        style={{ marginRight: 8 }}
                      /> */}
                      {tab.label}
                    </button>
                  )
                })}
              </div>
            </div>

            {!isInStandaloneMode && !isFirefox && (
              <div>
                <button
                  onClick={installed}
                  className='btn'
                  style={{
                    padding: '10px 30px',
                    marginLeft: '10px',
                    backgroundColor: '#2563eb',
                    color: 'white',
                  }}
                >
                  Installer
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Navigation mobile */}
      <div className='nav-mobile'>
        <div className='nav-mobile-flex'>
          {visibleTabs.map((tab) => {
            const Icon = tab.icon
            return (
              <button
                key={tab.id}
                onClick={() => {
                  setCurrentTab(tab.id)
                  window.scrollTo(0, 0)
                }}
                className={`nav-mobile-tab ${
                  currentTab === tab.id ? 'active' : ''
                }`}
              >
                <Icon size={24} />
                <span className='mobile-label'>{tab.label}</span>
              </button>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default Navigation
